let convertDateFormat = ( format, value ) => {
  format = format.replace(/yyyy/g, value.getFullYear());
  format = format.replace(/MM/g, ('0' + (value.getMonth() + 1)).slice(-2));
  format = format.replace(/dd/g, ('0' + value.getDate()).slice(-2));
  format = format.replace(/HH/g, ('0' + value.getHours()).slice(-2));
  format = format.replace(/mm/g, ('0' + value.getMinutes()).slice(-2));
  format = format.replace(/ss/g, ('0' + value.getSeconds()).slice(-2));
  format = format.replace(/SSS/g, ('00' + value.getMilliseconds()).slice(-3));
  return format;
}

let convertDateToDateMonth = ( value ) => {
  if( value == null) return ""
  value = value.substring(0,7)
  var values = value.split('-')
  
  return values[0] + "年" + values[1] + "月"
}

let convertDateToDate = ( value ) => {
  if( value == null) return ""
  value = value.substring(0,10)
  var values = value.split('-')
  
  return values[0] + "年" + values[1] + "月" + values[2] + "日"
}

let convertReturnDataToArray = ( value ) =>{
  var values = value.split("@")
  
  return [ values[0], ( values.length >= 2 ? values[1] : "" ) ]
}

export{ convertDateToDateMonth, convertDateFormat, convertDateToDate, convertReturnDataToArray }